import { AuthClient } from "@its-engineering-and-development/jwt-auth-client";
import { authServiceUrl } from "@app/lib/auth/auth-config";
import { authTokenStore } from "@app/lib/auth/token-store";

export const eventsAdminAuthClient = new AuthClient(
  {
    baseUrl: authServiceUrl,
    timeout: 10_000,
    autoRefresh: false,
    responseMode: "body",
    headers: {
      "X-Auth-Provider": "cognito",
    },
  },
  authTokenStore,
);
